import React from "react";
import { BarChart3 } from "lucide-react";
import BenchmarkMetricsKPIs from "./BenchmarkMetricsKPIs";

const metrics = [
    {
        metric: "Revenue",
        yourReport: "$2,600,000",
        industryBenchmark: "$250,000 - $500,000",
        comparison: (
            <span>
                Your revenue significantly exceeds the industry average, indicating exceptional performance. (Source: <a href="https://www.taxfyle.com/blog/food-truck-fortune-unveiling-the-earning-potential-of-running-a-food-truck" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Taxfyle</a>)
            </span>
        ),
    },
    {
        metric: "Net Income",
        yourReport: "$440,000",
        industryBenchmark: "$24,000 - $153,000",
        comparison: (
            <span>
                Your net income is well above the average range, suggesting superior profitability. (Source: <a href="https://www.therestauranthq.com/trends/food-truck-industry-statistics" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">The Restaurant HQ</a>)
            </span>
        ),
    },
    {
        metric: "Startup Costs",
        yourReport: "N/A",
        industryBenchmark: "$50,000 - $100,000",
        comparison: (
            <span>
                Typical startup costs for a food truck range between $50,000 and $100,000. (Source: <a href="https://en.wikipedia.org/wiki/Taco_trucks_in_Los_Angeles" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Wikipedia</a>)
            </span>
        ),
    },
    {
        metric: "Annual Licensing & Permits",
        yourReport: "N/A",
        industryBenchmark: "$28,276",
        comparison: (
            <span>
                Average annual expenditure on licenses, permits, and legal compliance is $28,276. (Source: <a href="https://www.uschamberfoundation.org/solutions/incubator/food-truck-nation" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">U.S. Chamber Foundation</a>)
            </span>
        ),
    },
];

const BenchmarkFinancialMetrics = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6 mb-8">
            {/* Header */}
            <div className="flex items-center space-x-2 mb-6">
                <BarChart3 className="h-6 w-6 text-green-600" />
                <h3 className="text-lg font-medium text-gray-900">Financial Benchmark Metrics</h3>
            </div>

            {/* Financial Table */}
            <div className="overflow-x-auto mb-8">
                <table className="w-full border-collapse border border-gray-300">
                    {/* Table Header */}
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Metric</th>
                            <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Your 2024 Report</th>
                            <th className="border border-gray-300 px-4 py-2 text-center font-semibold">Industry Benchmark</th>
                            <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Comparison</th>
                        </tr>
                    </thead>

                    {/* Table Body */}
                    <tbody>
                        {metrics.map((row, index) => (
                            <tr key={index} className="border-b border-gray-300">
                                <td className="border border-gray-300 px-4 py-2 font-bold">{row.metric}</td>
                                <td className="border border-gray-300 px-4 py-2 text-center">{row.yourReport}</td>
                                <td className="border border-gray-300 px-4 py-2 text-center">{row.industryBenchmark}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.comparison}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Industry Benchmarks 2024 KPIs - Not in a separate box */}

            <BenchmarkMetricsKPIs />
        </div>
    );
};

export default BenchmarkFinancialMetrics;
